if (!customElements.get('sc-store-benefits-rotator')) {
  class StoreBenefitsRotator extends HTMLElement {
    connectedCallback() {
      // Hybrid mode only runs on mobile; desktop shows all benefits in a static row.
      if (window.theme?.mediaMatches?.md) return;

      this.radios = this.querySelectorAll('.sc-store-benefits__radio');
      if (this.radios.length < 2) return;

      this.delay = (parseInt(this.dataset.linger, 10) || 7) * 1000;
      this.resumeAfter = 10000; // ms idle before auto-rotation resumes after a user tap
      this.isPaused = false;
      this.tick = this.tick.bind(this);

      // Radio change events bubble up — one listener catches every arrow tap.
      this.addEventListener('change', () => {
        this.isPaused = true;
        clearTimeout(this.timer);
        clearTimeout(this.resumeTimer);
        this.resumeTimer = setTimeout(() => {
          this.isPaused = false;
          this.timer = setTimeout(this.tick, this.delay);
        }, this.resumeAfter);
      });

      this.timer = setTimeout(this.tick, this.delay);
    }

    tick() {
      if (this.isPaused) return;

      // Skip ticking when offscreen to save battery on long pages.
      if (window.theme?.elementUtil?.isInViewport && !theme.elementUtil.isInViewport(this)) {
        this.timer = setTimeout(this.tick, this.delay);
        return;
      }

      const current = Array.from(this.radios).findIndex((r) => r.checked);
      const next = (current + 1) % this.radios.length;
      this.radios[next].checked = true;
      this.timer = setTimeout(this.tick, this.delay);
    }

    disconnectedCallback() {
      clearTimeout(this.timer);
      clearTimeout(this.resumeTimer);
    }
  }

  customElements.define('sc-store-benefits-rotator', StoreBenefitsRotator);
}
